export default {
  setServiceTemplate(state, payload) {
    state.serviceTemplate = payload
  },
  setServiceTemplates(state, payload) {
    state.serviceTemplates = payload
  },
  checkServiceTemplateById(state, id) {
    const SERVICE_TEMPLATE = _.find(state.serviceTemplates, template => template.id === id)
    if (SERVICE_TEMPLATE) {
      SERVICE_TEMPLATE.active = true
    }
  },
  uncheckServiceTemplateById(state, id) {
    const SERVICE_TEMPLATE = _.find(state.serviceTemplates, template => template.id === id)
    if (SERVICE_TEMPLATE) {
      SERVICE_TEMPLATE.active = false
    }
  },
  setServiceTemplatesFiltered(state, payload) {
    state.serviceTemplatesFiltered = payload
  },
}
